import { PaginationType } from 'common';
import { InspectionsActionType } from 'enums';
import { InspectionType } from 'state';

export const setInspections = (inspections: InspectionType[]) =>
  ({ type: InspectionsActionType.SET_INSPECTIONS, inspections } as const);

export const setCertainInspection = (inspection: InspectionType) =>
  ({ type: InspectionsActionType.SET_CERTAIN_INSPECTIONS, inspection } as const);

export const setInspectionsAfterScroll = (inspections: InspectionType[]) =>
  ({ type: InspectionsActionType.SET_INSPECTIONS_AFTER_SCROLL, inspections } as const);

export const searchInspections = (search: string) =>
  ({ type: InspectionsActionType.SEARCH_INSPECTIONS, search } as const);

export const setInspectionsLoadingStatus = (isLoading: boolean) =>
  ({ type: InspectionsActionType.SET_INSPECTIONS_LOADING_STATUS, isLoading } as const);

export const setInspectionsPagination = (pagination: PaginationType) =>
  ({ type: InspectionsActionType.SET_INSPECTIONS_PAGINATION, pagination } as const);
